import { g as t } from "./get-built-in.js";
var e = t("document", "documentElement");
export { e as h };